import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllTemplates,
  GetTemplateData,
} from "../../actions/Template/Template";
import "../../Assets/Styles/pages/imageProperties.scss";
import { deleteAll } from "../../Redux/WaterMarks/wateramarks";
import { setLoader } from "../../Redux/MainImage/imageSlice";
import NoTemplates from "../NoTemplates/noTemplates";

const Templates = ({ active }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  //reading main image from store
  const dispatch = useDispatch();
  const userSliceState = useSelector((state) => state["userSlice"]);
  // let prevState = waterMarksState.items;

  useEffect(() => {
    if (
      Object.keys(userSliceState.user_Auth).length &&
      Object.keys(userSliceState.template).length
    )
      setTemplates(userSliceState.template);
  }, [userSliceState, active]);

  useEffect(() => {
    if (
      Object.keys(userSliceState.user_Auth).length &&
      Object.keys(userSliceState.template).length
    )
      dispatch(GetAllTemplates());
  }, [active]);

  const handleLoad = () => {
    setLoading(false);
  };
  const handleTemplateClick = (template) => {
    dispatch(setLoader(true));
    dispatch(deleteAll());
    dispatch(GetTemplateData(template.id, [], false, true));

    // dispatch(
    //     setItem({
    //       type: "image",
    //       property: "template",
    //       id: Date.now(),
    //       x: 50,
    //       y: 50,
    //       deg: 0,
    //       scaleX: 1,
    //       scaleY: 1,
    //       src: template.media.largeUrl,
    //       opacity: 1
    //     })
    //   );
  };

  return (
    <Row className="text_16 productSansLight m-0 p-0 d-grid batchImageGrid">
      {templates.length ? (
        templates?.map((template, i) => {
          return (
            <div
              key={i}
              className="p-0 mt-3 d-flex flex-column justify-content-center align-items-center"
              onClick={() => handleTemplateClick(template)}
            >
              {loading && <CircularProgress />}
              <Row
                className={`border rounded m-0 p-0 w-100 ${
                  loading ? "d-none" : "d-flex"
                }`}
              >
                <img
                  alt="Template thumbnail"
                  className={`templatesThumb m-0 p-0`}
                  onLoad={handleLoad}
                  src={template.media.thumbUrl}
                />
              </Row>
              <Row className="productSansLight text-start w-100 line_height_100pc px-0 mt-2 m-0 text_12">
                {template.name}
              </Row>
            </div>
          );
        })
      ) : (
        <NoTemplates />
      )}
    </Row>
  );
};

export default Templates;
